export class LiteratureRevisionEstrutura {

  constructor(
    public id: number,
    public tema: string,
    public estrutura: number,
    public estruturaName: string,
    public qtdLaudas: number,
    public QtdParagrafos: number,
    public qtdPrgfIntro: number,
    public qtdPrgfConcl: number,
    public qtdPrgDesenv: number,
    public selectVisible: boolean = true,
    public FieldTextsVisible: boolean = false,
    public showFormStruct: boolean = true
  ){}

}
